import { put, takeLatest } from '@redux-saga/core/effects';
import { checkAllJson } from '../lib/fetch/cache';

const PARAMS = {
  post_by_date: {
    data_type: 'posts',
    after_action: 'SET_CAL_EVENTS',
  },
};

function* SAGA_BY_EVENT_DATE(action) {
  const { query_type, eventDate, startCursor } = action.payload;
  const param = PARAMS[query_type];
  if (!param) return;

  const ym = eventDate.endsWith('-') ? eventDate.slice(0, -1) : eventDate;
  const ssKey = encodeURIComponent(`${query_type}${eventDate}${startCursor || ''}`);

  yield put({ type: 'SET_PARAM', payload: { key: 'dbCalling', val: true } });

  // セッションキャッシュがなく、分割ロードでもない場合のみJSONキャッシュを試す
  if (!sessionStorage.getItem(ssKey) && !startCursor) {
    const ec = yield checkAllJson({ cache_name: `events_${ym}` });

    if (ec?.data && ec.ym === ym) {
      const items = ec.data.posts ?? ec.data.newses;
      yield put({ type: param.after_action, payload: { eventDate, items } });
    } else {
      yield put({ type: 'SET_CAL_NULL_EVENTS', payload: { eventDate } });
    }
  }

  yield put({ type: 'SET_PARAM', payload: { key: 'dbCalling', val: false } });
}

export default function* weatherWatcher() {
  yield takeLatest('SAGA_BY_EVENT_DATE', SAGA_BY_EVENT_DATE);
}
